export const useHubSpotForm = () => {
  const getHubspotFormIds = (container: HTMLElement) => {
    const rawForms = container.querySelectorAll('.hubspot-form')

    // Extract IDs using different methods
    return Array.from(rawForms)
      .map((rawForm: HTMLElement) => {
        // Method 1: Check for id attribute starting with hs-form-
        if (rawForm.id && rawForm.id.startsWith('hs-form-')) {
          return rawForm.id.replace('hs-form-', '')
        }

        // Method 2: Check for data-form-id attribute
        const dataFormId = rawForm.getAttribute('data-form-id')
        if (dataFormId) {
          return dataFormId
        }

        // Method 3: Check for a div with class hs-form inside with an ID
        const innerForm = rawForm.querySelector('.hs-form')
        if (innerForm && innerForm.id && innerForm.id.startsWith('hs-form-')) {
          return innerForm.id.replace('hs-form-', '')
        }

        // Method 4: Look for any element with an ID starting with hs-form-inside
        const innerElement = rawForm.querySelector('[id^="hs-form-"]')
        if (innerElement && innerElement.id) {
          return innerElement.id.replace('hs-form-', '')
        }

        // If no ID found, check if the element has textContent that might contain the form ID
        if (rawForm.textContent && rawForm.textContent.includes('formId')) {
          const match = /formId['":\s]+([a-zA-Z0-9-]+)/.exec(
            rawForm.textContent,
          )
          if (match && match[1]) {
            return match[1]
          }
        }

        return null
      })
      .filter(Boolean) as string[]
  }

  return {
    getHubspotFormIds,
  }
}
